import { Component, OnInit } from '@angular/core';
import { AqarService } from 'src/app/services/aqar/aqar.service';

@Component({
  selector: 'app-aqar23-c7-seven-one-one',
  templateUrl: './aqar23-c7-seven-one-one.component.html',
  styleUrls: ['./aqar23-c7-seven-one-one.component.scss']
})
export class Aqar23C7SevenOneOneComponent implements OnInit {
  session: { title: string, link: string }[] = [];
  constructor(private service: AqarService) {
  }

  ngOnInit(): void {
    this.session = this.service.getC711();
  }
}
